import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  keyTag: string
  valueTag: string
}

const DoubleBadge = ({ keyTag, valueTag }: Props): ReactElement => {
  return (
    <div className="double-badge-component">
      <div className="key-tag">{keyTag}</div>
      <div className="value-tag">{valueTag}</div>
    </div>
  )
}

export default DoubleBadge
